import type { CSSProperties } from 'react'

/** Inline CSS custom properties, typed for the style prop: vars({ '--d': '120ms' }) */
export const vars = (values: Record<string, string | number>): CSSProperties => {
    return values as CSSProperties
}

/** Stagger helper for the reveal classes in globals.css */
export const delay = (ms: number): CSSProperties => {
    return vars({ '--d': `${Math.round(ms)}ms` })
}
